import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Table, TableHeader, TableRow, TableHeaderColumn, TableBody, TableRowColumn, IconButton, Drawer,
  Card, CardHeader, CardText, CircularProgress, Dialog, FlatButton, TextField
} from "material-ui";
import Editar from "material-ui/svg-icons/image/edit";
import Observacion from "material-ui/svg-icons/action/visibility";
import Caracteristicas from "material-ui/svg-icons/action/assignment";
import Detalle from "material-ui/svg-icons/editor/format-list-bulleted";
import { cargarDetalleMod, cargarCaracteristicasMod, cerrarModalDetalle, cargarDetallePaquete, cerrarModalCaracteristicas, cargarCaracteristicasPaquetes, cargarModalObservacion, cerrarModalObservacion, CambiarObservacion, GuardarObservacion, OpenEditarPaquete, SeleccionarPaqueteEditar } from "./actions";
import EliminarPrestacionForm from "../EliminarPrestacionForm/view";
import EditarPrestacionForm from "../EditarPrestacionForm/view";
import styles from "../../styles/styles";
import PaginacionBd from "../../PaginacionV2/view";
import TablePaginationCustom from "../TablePagination/view";


class GrillaBusquedaPQ extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      listaItems: [],
    }
  }

  componentWillMount() { }

  EditEnabled = (idPrestacion) => {
    let result = false;
    this.props.prestacionesSolicitud.forEach((item) => {
      //console.log(item.idPaqueteEditar)
      if (idPrestacion === item.idPaqueteEditar) {
        result = true;
      }
    });
    //result = true;
    return result;
  }

  OpenEditarPaquete = (idPaquete, totalClinica, totalHMQ, totalMonto) => {
    const result = this.props.paquetes.filter(paquetes => paquetes.ID_PAQUETE === idPaquete);
    this.props.dispatch(cargarCaracteristicasMod([]));
    this.props.dispatch(cargarDetalleMod([]));
    this.props.dispatch(SeleccionarPaqueteEditar(idPaquete, result[0]));
    this.props.dispatch(cargarCaracteristicasPaquetes(idPaquete, 0));
    this.props.dispatch(cargarDetallePaquete(idPaquete, totalClinica, totalHMQ, totalMonto, 0));
    this.props.dispatch(OpenEditarPaquete());
  }

  OpenVerObservacion = (idPrestacion) => {
    const result = this.props.paquetes.filter(paquete => paquete.ID_PAQUETE === idPrestacion);
    let observacion = result[0].OBSERVACION;
    let idPaquete = result[0].ID_PAQUETE;
    /*if (this.props.observacionesGuardadas.length > 0) {
      var myArray = this.props.observacionesGuardadas;
      var newArray = myArray.filter((item) => (item.idPaquete === idPrestacion));
      console.log(newArray)
      if (newArray.length > 0) {
        observacion = newArray[0].observacion;
      }
    }*/
    this.props.dispatch(cargarModalObservacion(true, observacion, idPaquete));
  }

  OpenCaracteristicasPaquete = (idPaquete) => {
    this.props.dispatch(cargarCaracteristicasPaquetes(idPaquete, 1));
  }

  OpenDetallePaquete = (idPaquete, totalClinica, totalHMQ, totalMonto) => {
    this.props.dispatch(cargarDetallePaquete(idPaquete, totalClinica, totalHMQ, totalMonto, 1));
  }

  CerrarModalObservacion = () => {
    this.props.dispatch(cerrarModalObservacion(false));
    //this.props.dispatch(CambiarObservacion(null));
  }

  CerrarModalCaracteristicas = () => {
    this.props.dispatch(cerrarModalCaracteristicas(false));
  }

  CerrarModalDetalle = () => {
    this.props.dispatch(cerrarModalDetalle(false));
  }

  CambiarObservacion = (event) => {
    this.props.dispatch(CambiarObservacion(event.target.value));
  }

  GuardarObservacion = () => {
    this.props.dispatch(GuardarObservacion(this.props.observacion, this.props.idPaqueteObservacion));
    this.props.dispatch(cerrarModalObservacion(false));
  }


  render() {
    const menuListprestaciones = [];
    const menuListCaracteristicas = [];
    const menuListDetalle = [];

    this.props.paquetes.map((row, index) => (
      menuListprestaciones.push((
        <TableRow key={index}>
          <TableRowColumn id={row.ID} name={`ID_${row.ID_PAQUETE}`} style={{ visibility: "hidden" }}>{row.ID}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP1}>{row.PRES_CCOD_INTERV}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP2} title={row.PAQU_DESCRIPCION}>{row.PAQU_DESCRIPCION}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP3}>{new Intl.NumberFormat('es-CL', { currency: 'CLP', style: 'currency' }).format(row.TOTAL_CLINICA)}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP4}>{new Intl.NumberFormat('es-CL', { currency: 'CLP', style: 'currency' }).format(row.TOTAL_HMQ)}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP5}>{new Intl.NumberFormat('es-CL', { currency: 'CLP', style: 'currency' }).format(row.PAQU_MONTO_TOTAL)}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP6}>{row.PAQU_CODIGO_PRESTADOR}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP7}>{row.PRESTACION_SECUNDARIA}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP8}>{row.BILATERALIDAD}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP9}>{row.ARANCEL}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP10}>{row.HABITACION}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP11}>{row.RIESGO}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP12}>{(new Date(row.PAQU_INICIO_VIGENCIA)).toLocaleDateString("en-GB", { timeZone: "UTC" })}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP13}>{row.PAQU_TERMINO_VIGENCIA != null ? (new Date(row.PAQU_TERMINO_VIGENCIA)).toLocaleDateString("en-GB", { timeZone: "UTC" }) : null}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP14}>
            {!this.EditEnabled(row.ID_PAQUETE) ?
              <IconButton
                iconStyle={styles.svgStyleResultado}
                style={styles.iconStyleResultado}
                disabled={row.PAQU_TERMINO_VIGENCIA != null}
                onClick={() => this.OpenEditarPaquete(row.ID_PAQUETE, row.TOTAL_CLINICA, row.TOTAL_HMQ, row.PAQU_MONTO_TOTAL)}
              >
                <Editar />
              </IconButton> : null}
          </TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP14}>
            <IconButton
              iconStyle={styles.svgStyleResultado}
              style={styles.iconStyleResultado}
              onClick={() => this.OpenVerObservacion(row.ID_PAQUETE)}
            >
              <Observacion />
            </IconButton>
          </TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP14}>
            <IconButton
              iconStyle={styles.svgStyleResultado}
              style={styles.iconStyleResultado}
              onClick={() => this.OpenCaracteristicasPaquete(row.ID_PAQUETE)}
            >
              <Caracteristicas />
            </IconButton>
          </TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP14}>
            <IconButton
              iconStyle={styles.svgStyleResultado}
              style={styles.iconStyleResultado}
              onClick={() => this.OpenDetallePaquete(row.ID_PAQUETE, row.TOTAL_CLINICA, row.TOTAL_HMQ, row.PAQU_MONTO_TOTAL)}
            >
              <Detalle />
            </IconButton>
          </TableRowColumn>
        </TableRow>
      ))
    ));

    this.props.caracteristicasPaquete.map((row, index) => (
      menuListCaracteristicas.push((
        <TableRow key={index}>
          <TableRowColumn style={styles.datoTablaCaracteristicasP1}>{row.Tipo}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaCaracteristicasP1}>{row.Descripcion}</TableRowColumn>
        </TableRow>
      ))
    ));

    if (this.props.detallePaquete) {
      this.props.detallePaquete.map((row, index) => (
        menuListDetalle.push((
          <TableRow key={index}>
            <TableRowColumn style={styles.datoTablaDetalleP1}>{row.TIPO_ATENCION}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaDetalleP1}>{row.COD_PRES_ISAP}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaDetalleP1}>{row.COD_PRES_PREST}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaDetalleP1}>{row.GLOSA_PRES_PREST}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaDetalleP1}>{row.ITEM_IMED}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaDetalleP1}>{row.COD_PROF}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaDetalleP1}>{row.CANT_PRES}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaDetalleP1}>{(row.MONTO_UNITARIO).toLocaleString('de-DE')}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaDetalleP1}>{row.UNIDAD}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaDetalleP1}>{row.MEDICO_U_HOTELERIA}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaDetalleP1}>{row.BONO_RUT}</TableRowColumn>
          </TableRow>
        ))
      ));
    }

    return (
      <div>
        <div style={{ padding: "5px" }}>
          <Card
            initiallyExpanded
            zDepth={0}
          >
            <CardHeader
              actAsExpander
              showExpandableButton
              iconStyle={{ height: 20, width: 20, color: "#212121" }}
            /*style={{
              paddingTop: "0px", paddingBottom: "0px", maxWidth: "1500px", overflow: "auto",
            }}*/
            >
              <div style={styles.h1}>Resultado Búsqueda</div>
            </CardHeader>
            <CardText
              expandable
            /*style={{
              paddingTop: "0px", paddingBottom: "0px", maxWidth: "1500px", overflow: "auto",
            }}*/
            >
              {!this.props.loading ?
                <div>
                  {(!this.props.paquetes || this.props.paquetes.length === 0) ?
                    <span style={{ textAlign: "left" }}>
                      {this.props.loading != null ? "No se encontraron resultados" : "-"}
                    </span>
                    :
                    <div>
                      {<div id="tablaBusquedaPaquetes" style={{ overflow: "auto" }}>
                        <div style={{ width: "fit-content", overflowX: "auto", textAlign: "left" }}>
                          <Table
                            key="tablaBusquedaPaquetes"
                            fixedHeader
                            selectable={false}
                            style={{ overflow: "hidden" }}
                          >
                            <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                              <TableRow selectable={false}>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Código<br />Intervención</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP2}>Glosa Paquete Isapre</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP3}>Valor<br />Total Clinica</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP4}>Valor<br />Total HMQ</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP5}>Valor<br />Total Paquete</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP6}>Codigo Interno<br /> Paquete Prestador</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP7}>Caracteristica<br />Prestacion Secundaria</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP8}>Caracteristica<br />Bilateralidad</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP9}>Caracteristica<br />Arancel</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP10}>Caracteristica<br />Habitación</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP11}>Caracteristica<br />Riesgo</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP12}>Inicio Vigencia</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP13}>Fin Vigencia</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP14}>Editar</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP14}>Ver<br />Observación</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP14}>Todas Las<br />Características</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaBusquedaP14}>Detalle<br />Prestaciones</TableHeaderColumn>
                              </TableRow>
                            </TableHeader>
                            <TableBody
                              id="tablaBodyBusquedaPaquetes"
                              displayRowCheckbox={false}
                              deselectOnClickaway={false}
                              stripedRows
                            >
                              {menuListprestaciones}
                            </TableBody>
                          </Table>
                        </div>
                      </div>}
                      {
                        <TablePaginationCustom
                          key="pag_tablaBodyBusquedaPaquetes"
                          rowsPerPageDefault={5} // [5,10,15,20,25]
                          totalRows={this.props.totalPage}
                          pageDefault={1}
                          idTableBody="tablaBodyBusquedaPaquetes"
                          showRowsPerPage={false}
                          labelStyleBtnPage={{ fontSize: "11px" }}
                          overlayStyleBtnPage={{ borderRadius: 20 }}
                          rippleStyleBtnPage={{ borderRadius: 20 }}
                          buttonStyleBtnPage={{ borderRadius: 20 }}
                          styleBtnPage={{
                            paddingLeft: 0,
                            paddingRight: 0,
                            paddingTop: 0,
                            paddingBottom: 0,
                            height: 25,
                            width: "45px",
                            minWidth: "45px",
                            borderRadius: 20,
                            marginRight: 5,
                          }}

                          labelStyleRowsPerPage={styles.h4}
                          underlineStyleRowsPerPage={styles.underlineSelectField}
                          iconStyleRowsPerPage={styles.iconSelectField}
                          menuItemStyleRowsPerPage={styles.menuItemStyleSelectField}
                          selectedMenuItemStyleRowsPerPage={styles.selectedMenuItemSelectField}
                          styleRowsPerPage={styles.selectFiledStyle}
                        />}
                    </div>
                  }
                </div>
                :
                <CircularProgress />
              }
            </CardText>
          </Card>
        </div>
        <Drawer
          width="100%"
          openSecondary
          open={this.props.modalEliminarPrestacion}
          docked={false}
        >
          {(this.props.modalEliminarPrestacion) ?
            <EliminarPrestacionForm CambiosSinGuardar={this.props.CambiosSinGuardar} />
            : null}
        </Drawer>

        <Drawer
          width="100%"
          openSecondary
          open={this.props.modalEditarPaquete}
          docked={false}
        >
          {(this.props.modalEditarPaquete) ?
            <EditarPrestacionForm CambiosSinGuardar={this.props.CambiosSinGuardar} />
            : null}
        </Drawer>

        {this.props.openModal ?
          <Dialog
            key="modalobservacion"
            actions={[/*
              <FlatButton
                label="Guardar"
                secondary
                onClick={this.GuardarObservacion}
              />,*/
              <FlatButton
                label="Cerrar"
                secondary
                onClick={this.CerrarModalObservacion}
              />]}
            modal
            open={this.props.openModal}
            style={{ width: "100%", fontSize: "13px" }}
          >
            <div style={styles.h1}>Observación
            </div>
            <div className="row" style={{ paddingBottom: 25 }}></div>
            <TextField
              name="pq_observacion"
              id="pq_observacion"
              hintStyle={{ top: "3px", left: "3px", color: "rgba(0, 0, 0, 0.4)" }}
              underlineStyle={styles.underlineSelectField}
              inputStyle={styles.h4}
              value={this.props.observacion || ""}
              //onChange={this.CambiarObservacion}
              style={styles.textFieldSolicitudObservacion}
              multiLine
              rows={4}
              rowsMax={4}
              maxLength={400}
            />
          </Dialog> : null}

        {this.props.openModalCaracteristicas ?
          <Dialog
            key="modalcaracteristicas"
            actions={[
              <FlatButton
                label="Cerrar"
                secondary
                onClick={this.CerrarModalCaracteristicas}
              />]}
            modal
            autoScrollBodyContent={true}
            open={this.props.openModalCaracteristicas}
            style={{ width: "100%", fontSize: "13px" }}
          >
            <div style={styles.h1}>Características
            </div>
            <div className="row" style={{ paddingBottom: 25 }}></div>
            <div id="tablaModalCaracteristicas" style={{ overflow: "auto" }}>
              <div style={{ width: "fit-content", overflowX: "auto", textAlign: "left" }}>
                <Table
                  key="tablaModalCaracteristicas"
                  fixedHeader
                  selectable={false}
                  style={{ overflow: "hidden" }}
                >
                  <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                    <TableRow selectable={false}>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Tipo Atributo</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP2}>Descripción</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    id="tablaBodyModalCaracteristicas"
                    displayRowCheckbox={false}
                    deselectOnClickaway={false}
                    stripedRows
                  >
                    {menuListCaracteristicas}
                  </TableBody>
                </Table>
              </div>
            </div>
          </Dialog> : null}

        {this.props.openModalDetalle ?
          <Dialog
            key="modaldetalle"
            actions={[
              <FlatButton
                label="Cerrar"
                secondary
                onClick={this.CerrarModalDetalle}
              />]}
            modal
            autoScrollBodyContent={true}
            open={this.props.openModalDetalle}
            style={{ width: "100%", fontSize: "13px" }}
          >
            <div style={styles.h1}>Prestaciones en el Paquete
            </div>
            <div className="row" style={{ paddingBottom: 25 }}></div>
            <div>Valor Total Clinica: {new Intl.NumberFormat('es-CL', { currency: 'CLP', style: 'currency' }).format(this.props.totalClinica)}</div>
            <div>Valor Total HMQ: {new Intl.NumberFormat('es-CL', { currency: 'CLP', style: 'currency' }).format(this.props.totalHMQ)}</div>
            <div>Valor Total Paquete: {new Intl.NumberFormat('es-CL', { currency: 'CLP', style: 'currency' }).format(this.props.totalMonto)}</div>
            <div className="row" style={{ paddingBottom: 25 }}></div>
            <div id="tablaModalDetalle" style={{ overflow: "auto" }}>
              <div style={{ width: "fit-content", overflowX: "auto", textAlign: "left" }}>
                <Table
                  key="tablaModalDetalle"
                  fixedHeader
                  selectable={false}
                  style={{ overflow: "hidden" }}
                >
                  <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                    <TableRow selectable={false}>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Tipo Atención</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Código<br />Isapre</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Código<br />Prestador</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Glosa<br />Prestador</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Item IMED</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Código<br />Profesional</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Cantidad</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Monto Unitario</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Unidad</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Médico u Hotelería</TableHeaderColumn>
                      <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Bono RUT</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    id="tablaBodyModalDetalle"
                    displayRowCheckbox={false}
                    deselectOnClickaway={false}
                    stripedRows
                  >
                    {menuListDetalle}
                  </TableBody>
                </Table>
              </div>
            </div>
          </Dialog> : null}
      </div>
    );
  }
}

GrillaBusquedaPQ.defaultProps = {
  rutInstitucion: null,
  loading: null,
  openModal: false,
};

GrillaBusquedaPQ.propTypes = {
  paquetes: PropTypes.array.isRequired,
  caracteristicasPaquete: PropTypes.array.isRequired,
  detallePaquete: PropTypes.array,
  modalEditarPaquete: PropTypes.bool.isRequired,
  modalEliminarPrestacion: PropTypes.bool,
  idPraqueteEditar: PropTypes.number,
  // idPrestacionEliminar: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  tipoArancel: PropTypes.any.isRequired,
  rutInstitucion: PropTypes.number,
  isapre: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  CambiosSinGuardar: PropTypes.func.isRequired,
  prestacionesSolicitud: PropTypes.array.isRequired,
  listaItems: PropTypes.array,
  prestacionesPP: PropTypes.array,
  openModal: PropTypes.bool,
  openModalCaracteristicas: PropTypes.bool,
  openModalDetalle: PropTypes.bool,
  observacion: PropTypes.string,
  idPaqueteObservacion: PropTypes.number,
  totalClinica: PropTypes.number,
  totalHMQ: PropTypes.number,
  totalMonto: PropTypes.number,
  totalPage: PropTypes.number,
  //observacionesGuardadas: PropTypes.any,
};

const mapStateToProps = (state) => ({
  paquetes: state.filtroBusquedaPQ.paquetes,
  modalEditarPaquete: state.grillaBusquedaPQ.modalEditarPaquete,
  openModal: state.grillaBusquedaPQ.openModal,
  openModalCaracteristicas: state.grillaBusquedaPQ.openModalCaracteristicas,
  openModalDetalle: state.grillaBusquedaPQ.openModalDetalle,
  observacion: state.grillaBusquedaPQ.observacion,
  caracteristicasPaquete: state.grillaBusquedaPQ.caracteristicasPaquete,
  detallePaquete: state.grillaBusquedaPQ.detallePaquete,
  idPaqueteObservacion: state.grillaBusquedaPQ.idPaqueteObservacion,
  totalClinica: state.grillaBusquedaPQ.totalClinica,
  totalHMQ: state.grillaBusquedaPQ.totalHMQ,
  totalMonto: state.grillaBusquedaPQ.totalMonto,
  //observacionesGuardadas: state.grillaBusquedaPQ.observacionesGuardadas,
  //caracteristicasPaquete: state.grillaBusquedaPQ.caracteristicasPaquete,
  idPaqueteEditar: state.grillaBusquedaPQ.idPaqueteEditar,
  // idPrestacionEliminar: state.grillaBusqueda.idPrestacionEliminar,
  loading: state.filtroBusqueda.loading,
  tipoArancel: state.global.filtros_CAT.tipoArancel || 0,
  rutInstitucion: state.global.rutInstitucion,
  isapre: state.global.isapre,
  prestacionesSolicitud: state.grillaSolicitudPQ.prestacionesSolicitud,
  prestacionesPP: state.paginacionState.prestaciopnesPP,
  tablaBody: state.paginacionState.tablaBody,
  totalPage: state.filtroBusquedaPQ.pageSize,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(GrillaBusquedaPQ);



// WEBPACK FOOTER //
// ./src/components/Paquetes/GrillaBusquedaPQ/view.jsx